import InventoryType from "../../shared/enums/InventoryType";
import { useGetApiData, useGetApiDataAsMutate } from "shared/datalayer";
import ApiInventoryTaxConfigurationBasic from "../../shared/types/ApiInventoryTaxConfigurationBasic";
import ConsoleApi from "./enums/consoleApi";
import ApiEventAgendaWrapper from "shared/types/ApiEventAgendaWrapper";
import PublicApi from "shared/enums/PublicApi";
import { ApiRateCard } from "./modules/registration/configurations/ratecard/list/types";
import ApiRegistrationEnabledFeatures from "shared/types/ApiRegistrationEnabledFeatures";
import ApiEventOrganizationBasic from "../../shared/types/ApiEventOrganizationBasic";

interface GetTaxConfigurationArgsType {
  registrationId: string;
  contextId: string;
  inventoryType: InventoryType;
}

export function useGetTaxConfiguration(props: GetTaxConfigurationArgsType) {
  return useGetApiData<ApiInventoryTaxConfigurationBasic>(
    ConsoleApi.GET_TAX_CONFIGURATION_BY_ENTITY_AND_INVENTORY_TYPE,
    {
      params: {
        registrationId: props.registrationId,
        contextEntityId: props.contextId,
        inventoryType: props.inventoryType
      }
    },
    {
      enabled: Boolean(props.registrationId) && Boolean(props.contextId) && Boolean(props.inventoryType)
    }
  );
}

export function useFetchTaxConfiguration() {
  return useGetApiDataAsMutate<ApiInventoryTaxConfigurationBasic>(
    ConsoleApi.GET_TAX_CONFIGURATION_BY_ENTITY_AND_INVENTORY_TYPE
  );
}

export function useGetEventAgenda(eventId?: string, divisionId?: string) {
  return useGetApiData<ApiEventAgendaWrapper>(
    PublicApi.EVENT_AGENDA,
    { params: { eventId, divisionId } },
    { enabled: Boolean(eventId) }
  );
}

export function useGetSponsorOrganizationList(eventId?: string) {
  return useGetApiData<Array<ApiEventOrganizationBasic>>(
    PublicApi.SPONSOR_ORGANIZATIONS,
    { params: { eventId, fetchSponsor: true } },
    { enabled: Boolean(eventId) }
  );
}

export function useGetRateCardListByRegistrationAndInventoryTypes(
  registrationId: string,
  inventoryTypes: Array<InventoryType>
) {
  return useGetApiData<Array<ApiRateCard>>(
    ConsoleApi.GET_RATE_CARD_LIST_BY_INVENTORY_TYPE,
    {
      params: { inventoryTypes: inventoryTypes.join(","), registrationId }
    },
    {
      enabled: Boolean(inventoryTypes) && Boolean(registrationId)
    }
  );
}

export function useGetEnabledFeaturesByRegistrationId({ registrationId }: { registrationId?: string }) {
  return useGetApiData<ApiRegistrationEnabledFeatures>(
    ConsoleApi.REGISTRATION_GET_ENABLED_FEATURE,
    {
      params: { id: registrationId }
    },
    {
      enabled: Boolean(registrationId)
    }
  );
}
